const cargos = state => state.cargos;
const tipocargo = state => state.tipocargo;

export default {
  cargos,
  tipocargo
};